import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";
import { alpha, Button, Card, CardActions, CardContent, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: "66vw",
        minHeight: "calc(100vh - 200px)",
        [theme.breakpoints.down("sm")]: {
            minWidth: "100vw",
            minHeight: "calc(100vh - 110px)",
        },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        // flexWrap: "wrap",
        // flex: 1,
        textAlign: "center",
        "& > *": {
            // flexGrow: 1,
            width: "100%",
        },
        border: "none",
        backgroundColor: theme.palette.background.paper,
    },
    errorNumber: {
        textAlign: "center",
        fontSize: "10rem",
        color: alpha(theme.palette.primary.main, 0.125),
        [theme.breakpoints.down("sm")]: {
            fontSize: "6rem",
        },
    },
    pos: {
        margin: theme.spacing(10, 0),
        fontSize: "1.25rem",
    },
    cardActionsRoot: {
        alignItems: "center",
        justifyContent: "center",
    },
}));

const Page404 = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <Card className={classes.root} variant="outlined">
            <CardContent>
                <Typography variant="h2" component="div" className={classes.errorNumber}>
                    404
                </Typography>
                <Typography variant={"body1"} component={"h2"} className={classes.pos} color="textSecondary">
                    {t("Szukana strona nie została znaleziona.")}
                </Typography>
            </CardContent>
            <CardActions classes={{ root: classes.cardActionsRoot }}>
                <Button
                    variant={"contained"}
                    color={"primary"}
                    onClick={() => history.push("/")}
                    style={{ padding: "6px 32px" }}
                >
                    {t("Wróć do strony głównej")}
                </Button>
            </CardActions>
        </Card>
    );
};

export default Page404;
